import api from '../api';

const path = '/news';
const GENERATE_NEWS_TIMEOUT = 420000;

const getLatestNewsRequest = (lang, limit = 3) =>
    api.get(`${path}/latest`, { params: { lang, limit } });

const getNewsListRequest = (params) =>
    api.get(path, { params });

const getNewsBySlugRequest = (slug, lang) =>
    api.get(`${path}/${slug}`, { params: { lang } });

const getNewsByCategoryRequest = (category, lang, limit = 10, offset = 0) =>
    api.get(`${path}/category/${category}`, { params: { lang, limit, offset } });

const getNewsStatsRequest = () =>
    api.get(`${path}/stats`);

const generateNewsRequest = (payload) =>
    api.post(`${path}/generate`, payload, { timeout: GENERATE_NEWS_TIMEOUT });

export {
    getLatestNewsRequest,
    getNewsListRequest,
    getNewsBySlugRequest,
    getNewsByCategoryRequest,
    getNewsStatsRequest,
    generateNewsRequest,
};
